import groupTherapiesEditTemplate from './groupTherapiesEditTemplate.html';

export default function (nga, admin) {
    var group_therapies = admin.getEntity('group_therapies');
    group_therapies.listView()
        .title('{{ "Group Therapies" | translate }}')
        .fields([
            nga.field('group_id', 'reference')
                .targetEntity(admin.getEntity('groups'))
                .targetField(nga.field('name'))
                .label('Group'),
            nga.field('date', 'date')
                 // FIXME: use translations for date format
                .format('dd/MM/yyyy')
        ]).filters([
            nga.field('date', 'date'),
            nga.field('group_id', 'reference')
                .targetEntity(admin.getEntity('groups'))
                .targetField(nga.field('name'))
                .label('Group')
        ])
        .sortField('date')
        .sortDir('DESC')
        .actions(['create', 'filter'])
        .listActions(['edit']);

    group_therapies.editionView()
        .template(groupTherapiesEditTemplate)
        .fields([
            nga.field('group_id', 'reference')
                // FIXME: editable(false) seems not to kork on reference fields
                .editable(false)
                .targetEntity(admin.getEntity('groups'))
                .targetField(nga.field('name'))
                .cssClasses('col-sm-4'),
            // nga.field('date', 'date'),
            nga.field('events', 'referenced_list')
                .targetEntity(admin.getEntity('events'))
                .targetReferenceField('group_therapy_id')
                .targetFields([
                    // TODO: show title only when activity_id is null
                    nga.field('title').isDetailLink(true),
                    nga.field('activity_id', 'reference')
                        .targetEntity(admin.getEntity('activities'))
                        .targetField(nga.field('name'))
                        .isDetailLink(false),
                    // FIXME: check format
                    nga.field('start_time'),
                    nga.field('end_time')
                ])
                .listActions(['edit', 'delete'])
                .sortField('start_time')
                .sortDir('ASC')
        ]);

    // TODO: use custome templates
    return group_therapies;
}



// WEBPACK FOOTER //
// ./js/group_therapies/config.js